export default __webpack_public_path__ + "static/media/moscow.64fc9040.png";